import axios from "axios";

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json"
  }
});

apiClient.defaults.withCredentials = true;
apiClient.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

export default apiClient;
